import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 菜单分页
    GetTreeGridJson({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Module/GetTreeGridJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存菜单
    getSystemMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Module/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除菜单
    DeleteSystemMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Module/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取上级节点
    GetTreeSelectJson({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Module/GetTreeSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
